import moment from 'moment';

import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import parseDate from 'utils/parsers/parseDate';
import isMoment from 'utils/predicates/isMoment.util';
import isNotDateWorthy from 'utils/predicates/time/isNotDateWorthy.util';
import isValidDateObject from 'utils/predicates/time/isValidDateObject.util';

const L = logger('from');

const clone = (any) => moment(any).clone();

export const fromMomentToIso = (value) => (isMoment(value) ? value.toISOString(true) || '' : '');
export const fromMomentToTimestamp = (value) => (isMoment(value) ? value.valueOf() : NaN);
export const fromIsoToTimestamp = (value) => ('string' === typeof value ? parseDate(value) : NaN);
export const fromDateToZulu = (value) => (isValidDateObject(value) ? value.toISOString() : '');

export const fromAnyDateToDate = (any) => {
  try {
    if (any instanceof Date) return any;
    if (bad(any)) return new Date(NaN);

    return (isMoment(any) ? any : moment(any)).toDate();
  } catch (e) {
    L.warn('fromAnyDateToDate()', e);
    return new Date(NaN);
  }
};

export const fromAnyDateToIso = (any) => {
  try {
    return isNotDateWorthy(any) ? '' : fromMomentToIso(isMoment(any) ? any : moment(any));
  } catch (e) {
    L.warn('fromAnyDateToIso()', e);
    return '';
  }
};

export const fromAnyDateToTimestamp = (any) => {
  try {
    if (Number.isSafeInteger(any)) return any;
    if (isNotDateWorthy(any)) return NaN;

    return fromMomentToTimestamp(isMoment(any) ? any : moment(any));
  } catch (e) {
    L.warn('fromAnyDateToTimestamp()', e);
    return NaN;
  }
};

export const fromAnyDateToZulu = (any) => {
  try {
    return isNotDateWorthy(any) ? '' : fromMomentToZulu(isMoment(any) ? any : moment(any));
  } catch (e) {
    L.warn('fromAnyDateToZulu()', e);
    return '';
  }
};

// DEPRECATED: unless fixing legacy code, use fromAnyDateToZulu
export const fromMomentToZulu = (value) => {
  // true Moment instance is expected, but Moment() also accepts strings and even undefined
  if (typeof value === 'symbol') {
    // eslint-disable-next-line no-param-reassign
    value = String(value);
  }

  return fromAnyToString(moment(value).toISOString());
};

// aliases for ease of reading
const iso = fromMomentToIso;
const bad = isNotDateWorthy;

export const fromAnyDateToIsoMonthBgn = (any) => (bad(any) ? '' : iso(clone(any).startOf('month')));
export const fromAnyDateToIsoMonthEnd = (any) => (bad(any) ? '' : iso(clone(any).endOf('month')));

export const fromAnyDateToIsoWeekBgn = (any) => (bad(any) ? '' : iso(clone(any).startOf('isoWeek')));
export const fromAnyDateToIsoWeekEnd = (any) => (bad(any) ? '' : iso(clone(any).endOf('isoWeek')));

export const fromAnyDateToIsoDayBgn = (any) => (bad(any) ? '' : iso(clone(any).startOf('day')));
export const fromAnyDateToIsoDayEnd = (any) => (bad(any) ? '' : iso(clone(any).endOf('day')));

// DEPRECATED: unless fixing legacy code, use fromAnyDateToIsoWeekBgn
export const fromAnyDateToZuluWeekBgn = (any) => (bad(any) ? '' : fromMomentToZulu(clone(any).startOf('isoWeek')));
// DEPRECATED: unless fixing legacy code, use fromAnyDateToIsoWeekEnd
export const fromAnyDateToZuluWeekEnd = (any) => (bad(any) ? '' : fromMomentToZulu(clone(any).endOf('isoWeek')));

// DEPRECATED: unless fixing legacy code, use fromAnyDateToIsoDayBgn
export const fromAnyDateToZuluDayBgn = (any) => (bad(any) ? '' : fromMomentToZulu(clone(any).startOf('day')));
// DEPRECATED: unless fixing legacy code, use fromAnyDateToIsoDayEnd
export const fromAnyDateToZuluDayEnd = (any) => (bad(any) ? '' : fromMomentToZulu(clone(any).endOf('day')));
